import { render, staticRenderFns } from "./blockDashboard.vue?vue&type=template&id=7058baa1&scoped=true"
import script from "./blockDashboard.vue?vue&type=script&lang=js"
export * from "./blockDashboard.vue?vue&type=script&lang=js"
import style0 from "./blockDashboard.vue?vue&type=style&index=0&id=7058baa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7058baa1",
  null
  
)

export default component.exports